import { useEffect, useState } from "react"
import api from "../../api/api"
import { useAuth } from '../../features/auth/AuthContext'
import SearchComponent from "../SearchComponent/SearchComponent"
import { search } from "../../assets/images/images";
import { MenuItem, Pagination } from "@mui/material";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import { ReactSVG } from "react-svg";
import sort from "../../assets/images/sort.svg";
import StyledMenu from "../../components/StyleMenu"
import SearchBar from "../Search/SearchBar";



const CourseRevenue = () => {
  const { token } = useAuth()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchBar, setSearchBar] = useState("");
  const [copyData, setCopyData] = useState([])
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const PAGE_SIZE = 12;

  const [selectSort, setSelectSort] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const fetchCourseRevenue = async (page = 1) => {
      setData([]);


    setLoading(true);
    try {
      const response = await api.get('/payouts/courses/revenue/', {
        params: {
          page,
          search: debouncedSearch,
          sort: selectSort,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.data;
        // console.warn("data", data);

        setData(data)
        setCopyData(data)

        setNextUrl(data?.next || null);
        setPrevUrl(data?.previous || null);

        const count = response?.data?.count || 0;
        setTotalPages(Math.ceil(count / PAGE_SIZE));

      } else {
        console.error(response);

      }
    } catch (error) {
      console.error(error);

    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    fetchCourseRevenue(currentPage)
  }, [currentPage, debouncedSearch, selectSort])


  //   const cleanString = (str) => {
  //   return str.replace(/[^a-zA-Z0-9 ]/g, "").toLowerCase();
  // };

  // const handleSearch = (e) => {
  //   const value = e.target.value.trimStart();
  //   setSearchBar(value);

  //   if (e.key === "Enter") {
  //     setCurrentPage(1);
  //     setDebouncedSearch(value);
  //   }

  //   if (e.key === "Backspace" && value.length <= 1) {
  //     setCurrentPage(1);
  //     setDebouncedSearch("");
  //   }

  // }

  const handleSearch = (e) => {
  const value = e.target.value.trimStart();
  setSearchBar(value);
};
useEffect(() => {
  const timer = setTimeout(() => {
    setCurrentPage(1);
    setDebouncedSearch(searchBar);
  }, 500);

  return () => clearTimeout(timer);
}, [searchBar]);







  const changeSort = (sortType) => {
    setCurrentPage(1);
    setSelectSort(sortType);
  };

  return (
    <>

      <div className="filter-section">
        {/* <div className="search_header-container"> */}
        <SearchComponent
          search={search}
          searchPlaceholder="Search Course"
          searchValue="search"
          onchange={handleSearch}
          name="searchOption"
          value={searchBar}
        />
        {/* </div> */}
        <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
          <span style={{ cursor: "pointer" }} onClick={handleClick}><img src={sort} alt="sort" />Sort</span>
          {/* <ReactSVG
            id="demo-customized-button"
            aria-controls={open1 ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open1 ? "true" : undefined}
          // src={down_arrow}
          /> */}
          <StyledMenu
            anchorEl={anchorEl}
            id="account-menu"
            open={open1}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
              paper: {
                minWidth: 180,
                elevation: 0,
                sx: {
                  overflow: "visible",
                  // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    w0idth: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 4,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              selected={selectSort === "net_earnings_high_to_low"}
              onClick={() => changeSort("net_earnings_high_to_low")}
            >
              Net Earnings : High to Low
            </MenuItem>
            <MenuItem
              selected={selectSort === "net_earnings_low_to_high"}
              onClick={() => changeSort("net_earnings_low_to_high")}
            >
              Net Earnings : Low to High
            </MenuItem>
            <MenuItem
              selected={selectSort === "students_enrolled_high_to_low"}
              onClick={() => changeSort("students_enrolled_high_to_low")}
            >
              Students Enrolled : High to Low
            </MenuItem>
            <MenuItem
              selected={selectSort === "students_enrolled_low_to_high"}
              onClick={() => changeSort("students_enrolled_low_to_high")}
            >
              Students Enrolled : Low to High
            </MenuItem>

          </StyledMenu>
        </div>
      </div>

      <div className="!hidden lg:!block">
        <table className="revenue-table">
          <thead>
            <tr>
              <th>Course Name</th>
              <th>Created On</th>
              <th>Students Enrolled</th>
              <th>Gross Revenue</th>
              <th>Platform Fee</th>
              <th>Net Earnings</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr>
              <td colSpan={5} style={{ textAlign: "center", padding: "12px" }}>
                Loading Revenue history...
              </td>
            </tr>}
            {!loading && data.length === 0 && (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", padding: "12px" }}>
                  No Revenue history found.
                </td>
              </tr>
            )}
            {
              data.map((d) => {
                return (
                  <tr>
                    <td className='datafield'>  {d?.name?.length > 20 ? `${d.name.substring(0, 30)}...` : d?.name}</td>
                    <td className="font-medium">{d?.created_on ? new Date(d.created_on).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}</td>                    <td className='font-medium'>{d?.students_enrolled}</td>
                    <td className='font-medium'>{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.gross_revenue)}</td>
                    <td className='font-medium'>-{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.platform_fee)}</td>
                    <td className='font-medium'>{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.net_earnings)}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      {/* Pagination — desktop only */}

      {/* mobile crads */}
      <div className="!block md:!hidden">
{!loading && data.length === 0 && (
    <div className="flex flex-col items-center justify-center gap-2 bg-white rounded-2xl border border-gray-100 shadow-sm py-10 px-4">
      <p className="text-sm font-semibold text-gray-700">No Revenue history found.</p>
    </div>
  )}
        {!loading && data.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {data.map((d, index) => (
              <div
                key={d?.id || index}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4"
              >
                {/* Course name header */}
                {/* <div className="mb-3">
                  <p className="text-sm font-semibold text-gray-800 leading-snug">
                    {d?.name?.length > 50 ? `${d.name.substring(0, 50)}...` : d?.name}
                  </p>
                  <p className="text-xs text-gray-600 uppercase tracking-wide">
                    {d?.created_on
                      ? new Date(d.created_on).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                      : '—'}
                  </p>
                </div> */}

                {/* Divider */}
                <div className="border-t border-gray-100 mb-3" />

                {/* Info Grid — 2 cols */}
                <div className="grid grid-cols-2 gap-3">


                               {/* Course Name */}
                     <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Course Name
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                    {d?.name?.length > 50 ? `${d.name.substring(0, 50)}...` : d?.name}
                    </span>
                  </div>

                                    {/* Created On */}
                     <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Created On
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
  {d?.created_on
                      ? new Date(d.created_on).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                      : '—'}                    </span>
                  </div>

                                    {/* Students Enrolled */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Students Enrolled
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.students_enrolled ?? "—"}
                    </span>
                  </div>

                  {/* Gross Revenue */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Gross Revenue
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.gross_revenue)}
                    </span>
                  </div>

                  {/* Platform Fee */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Platform Fee
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      -{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.platform_fee)}
                    </span>
                  </div>

                  {/* Net Earnings */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Net Earnings
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.net_earnings)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
            {totalPages > 1 && (
        <div className='pagination-revenue'>
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              siblingCount={1}
              boundaryCount={1}
            />
          </Grid>
        </div>
      )}
    </>
  )
}

export default CourseRevenue;